declare global {
  interface Window {
    Tawk_API?: any;
    Tawk_LoadStart?: Date;
  }
}

export function setTawkUserAttributes(
  userId: number | string,
  email: string,
  name?: string
): void {
  if (typeof window === "undefined" || !window.Tawk_API) {
    // Если Tawk_API еще не загружен, устанавливаем обработчик onLoad
    window.Tawk_API = window.Tawk_API || {};
    window.Tawk_API.onLoad = function () {
      setAttributes(userId, email, name);
    };
  } else {
    // Если Tawk_API уже загружен, устанавливаем атрибуты сразу
    setAttributes(userId, email, name);
  }
}

function setAttributes(
  userId: number | string,
  email: string,
  name?: string
): void {
  if (!window.Tawk_API || !window.Tawk_API.setAttributes) {
    console.warn("Tawk_API.setAttributes is not available");
    return;
  }

  const attributes: Record<string, string | number> = {
    id: String(userId),
    email: email,
  };

  if (name) {
    attributes.name = name;
  }

  window.Tawk_API.setAttributes(attributes, function (error: any) {
    if (error) {
      console.error("Tawk.to setAttributes error:", error);
    } else {
      console.log("Tawk.to attributes set successfully:", attributes);
    }
  });
}

export function initTawkWithUser(
  userId: number,
  email: string,
  name?: string
): void {
  // Если виджет еще не загружен, устанавливаем обработчик onLoad
  if (!window.Tawk_API) {
    window.Tawk_API = window.Tawk_API || {};
    const originalOnLoad = window.Tawk_API.onLoad;

    window.Tawk_API.onLoad = function () {
      if (originalOnLoad && typeof originalOnLoad === "function") {
        originalOnLoad();
      }
      setAttributes(userId, email, name);
    };
  } else {
    // Если виджет уже загружен, устанавливаем атрибуты сразу
    setAttributes(userId, email, name);
  }
}
